import {  AlertUpdateBody } from "../../../../page-controller-mod/page-serv/settings/notification-set/ts/setting-notification.type";
import { SettingChange } from "./settings-draft.context";

export const buildNotificationPayload = (changes: SettingChange[]): AlertUpdateBody => { //NOSONAR
  const body: AlertUpdateBody = {};

  const ensure = {
    alert: /* istanbul ignore next */ () => (body.alert ??= {}), //NOSONAR
    inbox: () => ((body.alert ??= {}).inbox ??= {}), //NOSONAR 
    workflow: () => ((body.alert ??= {}).workflow ??= {}), //NOSONAR
    application: () => ((body.alert ??= {}).application ??= {}), //NOSONAR
    announcement: () => ((body.alert ??= {}).announcement ??= {}), //NOSONAR
  };

  for (const c of changes) {
    if (c.pageKey !== "notification") continue; //NOSONAR
    if (c.type !== "toggle") continue; //NOSONAR

    const v = Boolean(c.value);

    // Group 1 — Notification
    if (c.groupId === 1 && c.itemId === 1) ensure.inbox().enabled = v; //NOSONAR
    if (c.groupId === 1 && c.itemId === 2) ensure.workflow().enabled = v; //NOSONAR
    if (c.groupId === 1 && c.itemId === 3) ensure.application().enabled = v; //NOSONAR
    if (c.groupId === 1 && c.itemId === 4) ensure.announcement().enabled = v; //NOSONAR
  }

  return body;
};